/* Выбор цветов внутри набора Dana. 28.08.2026.

   Основная работа идет без скрипта: у каждого select стоит name
   properties[Shade N] и атрибут form с тем же id, что тема считает в
   product_form_id. Скрипт нужен для трех вещей.

   1. Картинка слота меняется вслед за выбором.
   2. Линейки длиннее 50 позиций Liquid не отдает (потолок collection.products),
      остальное дотягивается из /collections/<handle>/products.json. Запрос на
      линейку ровно один, результат общий для всех слотов этой линейки: три
      слота Move On на Restock раньше давали три одинаковых запроса и ловили 429.
   3. Запасной путь на случай, если браузер привязку по атрибуту form не поднял:
      тогда в форму кладутся скрытые input properties[...]. Искать форму через
      select.form.id нельзя, там named access и возвращается input name=id.
*/
(function () {
  var GRAN = 50; // столько позиций максимум отдает Liquid

  function корень() {
    return document.querySelector('[data-dana-shades]');
  }

  function форма(root) {
    var f = document.getElementById(root.getAttribute('data-form') || '');
    if (f && f.tagName === 'FORM' && (f.getAttribute('action') || '').indexOf('/cart/add') >= 0) return f;
    return document.querySelector('product-form form[action*="/cart/add"]');
  }

  function поле(f, имя) {
    var есть = f.querySelector('input[type="hidden"][data-dana-prop="' + имя + '"]');
    if (есть) return есть;
    var i = document.createElement('input');
    i.type = 'hidden';
    i.name = 'properties[' + имя + ']';
    i.setAttribute('data-dana-prop', имя);
    f.appendChild(i);
    return i;
  }

  function синхрон(f, sel) {
    // Привязка по атрибуту form уже работает, дублировать значение нельзя:
    // в форме окажутся два поля с одним именем.
    if (sel.form === f) return;
    поле(f, sel.getAttribute('data-prop')).value = sel.value;
  }

  function картинка(слот, sel) {
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    var src = opt.getAttribute('data-img');
    var img = слот.querySelector('.dana-shade__img');
    if (src && img) {
      img.src = src;
      img.alt = opt.textContent;
    }
  }

  var кэш = {};
  function линейка(handle) {
    if (кэш[handle]) return кэш[handle];
    var url = '/collections/' + handle + '/products.json?limit=250';
    кэш[handle] = fetch(url)
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .catch(function () {
        // Одна попытка повтора: 429 у Shopify снимается через несколько секунд.
        return new Promise(function (ok) { setTimeout(ok, 2500); })
          .then(function () { return fetch(url); })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); });
      });
    return кэш[handle];
  }

  function ширина(src) {
    if (!src) return src;
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=300';
  }

  function дотянуть(root, слот) {
    var sel = слот.querySelector('.dana-shade__select');
    var handle = слот.getAttribute('data-collection');
    return линейка(handle).then(function (d) {
      if (!d || !d.products) return;
      var было = {};
      for (var i = 0; i < sel.options.length; i++) {
        было[sel.options[i].getAttribute('data-handle')] = true;
      }
      var деф = слот.getAttribute('data-default');
      d.products.forEach(function (p) {
        if (было[p.handle]) return;
        var живой = (p.variants || []).some(function (v) { return v.available; });
        if (!живой) return;
        var o = document.createElement('option');
        o.value = p.title;
        o.textContent = p.title;
        o.setAttribute('data-handle', p.handle);
        o.setAttribute('data-img', p.images && p.images[0] ? ширина(p.images[0].src) : '');
        sel.appendChild(o);
      });
      пересортировать(sel);
      // Цвет по умолчанию мог лежать за потолком в 50 позиций: тогда Liquid
      // предвыбрал первый живой, а настоящий дефолт приехал только сейчас.
      for (var j = 0; j < sel.options.length; j++) {
        if (sel.options[j].getAttribute('data-handle') === деф) {
          sel.selectedIndex = j;
          картинка(слот, sel);
          break;
        }
      }
    }).catch(function () {
      var w = root.querySelector('[data-dana-warn]');
      if (w) w.hidden = false;
    });
  }

  function пересортировать(sel) {
    var знач = sel.value;
    var arr = Array.prototype.slice.call(sel.options);
    arr.sort(function (a, b) {
      return a.textContent.localeCompare(b.textContent, 'en', { numeric: true });
    });
    arr.forEach(function (o) { sel.appendChild(o); });
    sel.value = знач;
  }

  function дубли(root) {
    // Два слота одной линейки с одинаковым цветом это обычно промах, а не
    // выбор: набор задуман на разные оттенки. Не блокируем, только говорим.
    var видел = {};
    var есть = false;
    var сел = root.querySelectorAll('.dana-shade__select');
    Array.prototype.forEach.call(сел, function (s) {
      var ключ = s.closest('.dana-shade').getAttribute('data-collection') + '::' + s.value;
      if (видел[ключ]) есть = true;
      видел[ключ] = true;
    });
    var w = root.querySelector('[data-dana-dup]');
    if (w) w.hidden = !есть;
  }

  function запустить() {
    var root = корень();
    if (!root || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');
    var f = форма(root);
    var слоты = root.querySelectorAll('.dana-shade');

    Array.prototype.forEach.call(слоты, function (слот) {
      var sel = слот.querySelector('.dana-shade__select');
      if (!sel) return;
      if (f) синхрон(f, sel);
      sel.addEventListener('change', function () {
        картинка(слот, sel);
        if (f) синхрон(f, sel);
        дубли(root);
      });
      if (parseInt(слот.getAttribute('data-shown') || '0', 10) >= GRAN) {
        дотянуть(root, слот).then(function () { if (f) синхрон(f, sel); });
      }
    });

    // Страховка на отправку: если форму кто-то перерисовал, поля успеют встать
    // до того, как тема соберет FormData.
    if (f) {
      f.addEventListener('submit', function () {
        Array.prototype.forEach.call(слоты, function (слот) {
          var s = слот.querySelector('.dana-shade__select');
          if (s) синхрон(f, s);
        });
      }, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', запустить);
  } else {
    запустить();
  }
  document.addEventListener('shopify:section:load', function () {
    var r = корень();
    if (r) r.removeAttribute('data-ready');
    запустить();
  });
})();
